module.exports = __webpack_public_path__ + "static/media/amela.c9a56ce6.svg";